// AgencyJobInvoiceDrawer's reads (finance-real, the user 2026-10-23): a client invoice opened on a /finance tab other than
// Invoices, from the client drawer: it, found in every client's invoices as the Invoices tab finds it, and its client's
// jobs, the ones on it and the active ones a draft can take.
import type { UseQueryResult } from "@tanstack/react-query";
import { useAgencyInvoices, useClientJobs } from "../../hooks/useLineJobs";
import type { AgencyJobInvoice, AgencyJobInvoicesResponse, ClientJobsResponse } from "../../types";

export interface AgencyJobInvoiceDrawerModel {
  invoicesQuery: UseQueryResult<AgencyJobInvoicesResponse>;
  /** Undefined while the list loads, or when it has no such invoice. */
  invoice: AgencyJobInvoice | undefined;
  /** Its client's read, for the jobs; idle until the invoice is found. */
  clientQuery: UseQueryResult<ClientJobsResponse>;
}

export function useAgencyJobInvoiceDrawer(invoiceId: string): AgencyJobInvoiceDrawerModel {
  const invoicesQuery = useAgencyInvoices();
  const invoice = invoicesQuery.data?.invoices.find((i) => i.id === invoiceId);
  return { invoicesQuery, invoice, clientQuery: useClientJobs(invoice?.client.id) };
}
